const {
  VITE_BASE_HOST,
  VITE_BASE_ENVIRONMENT,
  VITE_GTM_ID,
  VITE_MAX_RETRY,
  VITE_MAX_QUANTITY_PER_PRODUCT
} = import.meta.env;

const CART_URL = `${VITE_BASE_HOST || 'https://be-paris-backend-cl-ms-api-dev.ccom-stg.paris.cl'}/carts`;

const PRODUCT_URL = `${VITE_BASE_HOST || 'https://be-paris-backend-cl-ms-api-dev.ccom-stg.paris.cl'}/products`;
const LOCALE = 'es-CL';
const CUSTOMERS = `${VITE_BASE_HOST || 'https://be-paris-backend-cl-ms-api-dev.ccom-stg.paris.cl'}/customers`;
const ACTIVE_CART_URL = `${CART_URL}/active-cart`;
const GTM_ID = VITE_GTM_ID;
const MAX_RETRY = +VITE_MAX_RETRY || 3;
const MAX_QUANTITY_PER_PRODUCT = +VITE_MAX_QUANTITY_PER_PRODUCT || 20;
const SET_BILLING_ADDRESS_URL = `${CART_URL}/wedding/:idWedding/billing-address`;

enum Environments {
  Local = 'LOCAL',
  Dev = 'DEV',
  Staging = 'STG',
  Production = 'PROD'
}

type EnvironmentValue = 'development' | 'staging' | 'production';

export const loginEnv = (): EnvironmentValue => {
  switch (VITE_BASE_ENVIRONMENT) {
    case 'DEV':
    default:
      return 'development';
    case 'STG':
      return 'staging';
    case 'PRD':
      return 'production';
  }
};

const getHomeUrl = (): string => {
  switch (VITE_BASE_ENVIRONMENT) {
    case 'DEV':
      return 'https://development.ccom-stg.paris.cl/home';
    case 'STG':
      return 'https://staging.ccom-stg.paris.cl/home';
    case 'PRD':
      return 'https://www.paris.cl/home';
    default:
      return 'https://www.paris.cl/home';
  }
};

const HOME_URL = getHomeUrl();

export default {
  CART_URL,
  PRODUCT_URL,
  LOCALE,
  CUSTOMERS,
  VITE_BASE_ENVIRONMENT,
  Environments,
  ACTIVE_CART_URL,
  GTM_ID,
  MAX_RETRY,
  MAX_QUANTITY_PER_PRODUCT,
  SET_BILLING_ADDRESS_URL,
  loginEnv,
  HOME_URL
};
